'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import dynamic from 'next/dynamic';
import { Field } from 'react-final-form';
import type { FieldValidator } from 'final-form';
import { useTranslation } from 'react-i18next';
import { TextInput, TextareaInput, PhoneInput } from '@/components/inputs';
import { StepSection } from '../StepSection';
import { FIELD_INCIDENT_DATE, FIELD_INCIDENT_PLACE, FIELD_INCIDENT_DESCRIPTION, FIELD_FULL_NAME, FIELD_DATE_OF_BIRTH, FIELD_EMAIL, FIELD_PHONE, FIELD_BANK_ACCOUNT, type BankAccountValue } from '../InsuranceReportForm.types';
import { FIELD_BANK_CODE, FIELD_SECOND_PART, DatePickerInput } from '@mallpay/orbis';
import { pipeValidators, required, email, phone } from '@/utils/validators';
const BankAccountInput = dynamic(() => import('@mallpay/orbis').then(mod => ({
  default: mod.BankAccountInput
})), {
  ssr: false,
  loading: () => <div className="h-14 w-full rounded-2xl bg-gray-50 opacity-50" />
});
export const MainInformationStep = () => {
  const $ = _c(50);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["insuranceReport", "core", "overpayRefund"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = value => {
      if (!value) {
        return t("core:forms.error.required");
      }
      const values = Object.values(value);
      if (values.every(_temp)) {
        return t("core:forms.error.required");
      }
      if (!value[FIELD_BANK_CODE] || !value[FIELD_SECOND_PART]) {
        return t("overpayRefund:fields.bankAccountRequired");
      }
    };
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const validateBankAccount = t1;
  let t2;
  if ($[3] !== t) {
    t2 = t("insuranceReport:form.mainInformation.title");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("insuranceReport:form.mainInformation.titles.incidentDetails");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <p className="font-semibold">{t3}</p>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = <Field name={FIELD_INCIDENT_DATE} validate={required}>{t6 => {
        const {
          input,
          meta
        } = t6;
        const currentValue = input.value ? new Date(input.value) : undefined;
        return <DatePickerInput input={input} meta={meta} label={t("insuranceReport:form.mainInformation.fields.incidentDate")} containerClassName="max-w-none" toggleClassName="z-50 [&+div]:z-50" defaultValue={currentValue ? {
          startDate: currentValue,
          endDate: currentValue
        } : {
          startDate: null,
          endDate: null
        }} maxDate={new Date()} onChange={value_0 => {
          const date = value_0?.startDate;
          input.onChange(date);
        }} />;
      }}</Field>;
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = <Field name={FIELD_INCIDENT_PLACE} validate={required}>{fieldRenderProps => <TextInput {...fieldRenderProps} label={t("insuranceReport:form.mainInformation.fields.incidentPlace")} />}</Field>;
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = <Field name={FIELD_INCIDENT_DESCRIPTION} validate={required}>{fieldRenderProps_0 => <TextareaInput {...fieldRenderProps_0} label={t("insuranceReport:form.mainInformation.fields.incidentDescription")} />}</Field>;
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t4 || $[16] !== t5 || $[17] !== t6 || $[18] !== t7) {
    t8 = <div className="flex flex-col gap-4">{t4}{t5}{t6}{t7}</div>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t) {
    t9 = t("insuranceReport:form.mainInformation.titles.personalInformation");
    $[20] = t;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t9) {
    t10 = <p className="font-semibold">{t9}</p>;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t) {
    t11 = <Field name={FIELD_FULL_NAME} validate={required}>{fieldRenderProps_1 => <TextInput {...fieldRenderProps_1} label={t("insuranceReport:form.mainInformation.fields.fullName")} />}</Field>;
    $[24] = t;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t) {
    t12 = <Field name={FIELD_DATE_OF_BIRTH} validate={required}>{t13 => {
        const {
          input: input_0,
          meta: meta_0
        } = t13;
        const currentValue_0 = input_0.value ? new Date(input_0.value) : undefined;
        return <DatePickerInput input={input_0} meta={meta_0} label={t("insuranceReport:form.mainInformation.fields.dateOfBirth")} containerClassName="max-w-none" toggleClassName="z-50 [&+div]:z-50" defaultValue={currentValue_0 ? {
          startDate: currentValue_0,
          endDate: currentValue_0
        } : {
          startDate: null,
          endDate: null
        }} maxDate={new Date()} onChange={value_1 => {
          const date_0 = value_1?.startDate;
          input_0.onChange(date_0);
        }} />;
      }}</Field>;
    $[26] = t;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = pipeValidators(required, email);
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t) {
    t14 = <Field name={FIELD_EMAIL} validate={t13}>{fieldRenderProps_2 => <TextInput {...fieldRenderProps_2} label={t("insuranceReport:form.mainInformation.fields.email")} />}</Field>;
    $[29] = t;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = pipeValidators(required, phone);
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t) {
    t16 = <Field name={FIELD_PHONE} validate={t15}>{fieldRenderProps_3 => <PhoneInput {...fieldRenderProps_3} label={t("insuranceReport:form.mainInformation.fields.phone")} />}</Field>;
    $[32] = t;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t) {
    t17 = fieldRenderProps_4 => <div className="pt-2"><BankAccountInput className="orbis-input-bank-account" {...fieldRenderProps_4} type="local" country="CZ" isMobile={false} label={t("insuranceReport:form.mainInformation.fields.accountNumber")} analyticsParam="insuranceReportBankAccount" testId="insuranceReportBankAccount" ariaLabels={{
        [FIELD_BANK_CODE]: t("overpayRefund:fields.bankCode"),
        [FIELD_SECOND_PART]: t("overpayRefund:fields.secondPart")
      }} /></div>;
    $[34] = t;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t17 || $[37] !== validateBankAccount) {
    t18 = <Field name={FIELD_BANK_ACCOUNT} validate={validateBankAccount}>{t17}</Field>;
    $[36] = t17;
    $[37] = validateBankAccount;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== t10 || $[40] !== t11 || $[41] !== t12 || $[42] !== t14 || $[43] !== t16 || $[44] !== t18) {
    t19 = <div className="flex flex-col gap-4">{t10}{t11}{t12}{t14}{t16}{t18}</div>;
    $[39] = t10;
    $[40] = t11;
    $[41] = t12;
    $[42] = t14;
    $[43] = t16;
    $[44] = t18;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] !== t19 || $[47] !== t2 || $[48] !== t8) {
    t20 = <StepSection title={t2} anchorKey="insuranceReport.form.mainInformation.title">{t8}{t19}</StepSection>;
    $[46] = t19;
    $[47] = t2;
    $[48] = t8;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  return t20;
};
function _temp(v) {
  return !v;
}